import Check from "../../../../assets/icons/Check-black.svg";
import "./DetailPrivilegeTable.scss";
import TitlePrivilegeTable from "./TitlePrivilegeTable/TitlePrivilegeTable";
import ToolTip from "./TitlePrivilegeTable/ToolTip/ToolTip";
import {
  dataAllCH,
  dataBeginnerCH,
  dataPremiumCH,
  dataAllCH2,
} from "./TitlePrivilegeTable/DataPrivilege/DataPrivilegeCH";
import {
  dataAllMX,
  dataBeginnerMX,
  dataPremiumMX,
  dataAllMX2,
} from "./TitlePrivilegeTable/DataPrivilege/DataPrivilegeMX";
import { useEffect, useState } from "react";

import CrossGray from "../../../../assets/icons/CrossGray.svg";

import Down from "../../../../assets/images/Down.svg";

const replaceChileWithCheck = (data) => {
  for (let prop in data) {
    data[prop] = data[prop].map((val) => {
      if (val === "Si") {
        return <img src={Check} alt="Check" />;
      }
      return val;
    });
  }
  return data;
};

export default function TablePrivilege(props) {
  const { activeCountry } = props;
  const [activeIndex, setActiveIndex] = useState(-1);

  const [isDesktop, setIsDesktop] = useState(false);
  const modifiedData = replaceChileWithCheck(
    activeCountry === "cl" ? dataAllCH : dataAllMX
  );
  const modifiedData2 = replaceChileWithCheck(
    activeCountry === "cl" ? dataBeginnerCH : dataBeginnerMX
  );
  const modifiedData3 = replaceChileWithCheck(
    activeCountry === "cl" ? dataPremiumCH : dataPremiumMX
  );
  const handleToolTipClick = (index) => {
    setActiveIndex(activeIndex === index ? -1 : index);
  };
  const columnas = Object.keys(modifiedData);
  const columnas2 = Object.keys(modifiedData2);
  const columnas3 = Object.keys(modifiedData3);

  const [pricePlan, setPricePlan] = useState("basic");
  const [openPlan, setOpenPlan] = useState(false);
  console.log("pricePlan", pricePlan);
  const activeData = activeCountry === "cl" ? dataAllCH2 : dataAllMX2;

  useEffect(() => {
    function handleResize() {
      setIsDesktop(window.innerWidth >= 769);
    }

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  let stickyWithBanner = "";

  if (document.getElementsByClassName("banner-modal").length > 0) {
    stickyWithBanner = "containerMenuStickyWithBanner";
  }
  return (
    <div className="responsiveTable containerPlanMobile">
      {isDesktop ? (
        <table className="containerTable">
          <thead>
            <tr>
              <th className="Title">Aceptación de pagos </th>

              <th>
                <TitlePrivilegeTable
                  titlePrivilege="Basic"
                  detailPrivilege={
                    activeCountry === "cl"
                      ? "Min. $29.000 CLP/mes"
                      : "Min. $540 MXN/mes"
                  }
                  hrefPrivilege="https://dashboard.etpay.com/sign-up?plan_selected=Basic"
                  backgroundColor="#E6E6E6"
                />
              </th>
              <th></th>
              <th>
                <TitlePrivilegeTable
                  titlePrivilege="Starter"
                  detailPrivilege={
                    activeCountry === "cl"
                      ? "$69.900 +IVA CLP/mes"
                      : "$1,790 MXN/mes"
                  }
                  hrefPrivilege="https://dashboard.etpay.com/sign-up?plan_selected=Starter"
                  backgroundColor="#140F33"
                  color="#FFFFFF"
                />
              </th>
              <th></th>
              <th>
                <TitlePrivilegeTable
                  titlePrivilege="Plus"
                  detailPrivilege={
                    activeCountry === "cl"
                      ? "$129.900 +IVA CLP/mes"
                      : "$3,990 MXN/mes"
                  }
                  hrefPrivilege="https://dashboard.etpay.com/sign-up?plan_selected=Plus"
                  backgroundColor="#140F33"
                  color="#FFFFFF"
                />
              </th>
              <th></th>
              <th>
                <TitlePrivilegeTable
                  titlePrivilege="Enterprise"
                  detailPrivilege="A la medida"
                  hrefPrivilege="https://dashboard.etpay.com/sign-up?plan_selected=Enterprise"
                  backgroundColor="#E6E6E6"
                  textButton="Contáctanos"
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {activeData.map((item, index) =>
              item.fullTitle ? (
                <tr className="beneficioTitle">
                  <td class="FirstColumn">
                    <p class="beneficio"> {item.fullTitle} </p>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              ) : (
                <tr>
                  <td className="FirstColumn FirstColumnDirection">
                    {
                      <p className={item.tooltip && "pTooltip"}>
                        {item.titleSupIni && (
                          <sup style={{ fontSize: 14 }}>{item.titleSupIni}</sup>
                        )}
                        {item.title}{" "}
                        {item.titleSup && <sup>{item.titleSup}</sup>}
                        {item.tooltip && (
                          <ToolTip
                            title={item.tooltip}
                            index={index}
                            isActive={activeIndex === index}
                            onClick={handleToolTipClick}
                          />
                        )}
                      </p>
                    }

                    {item.text && (
                      <p className="textDescription">{item.text}</p>
                    )}
                    {item.text2 && (
                      <p className="textDescription">
                        {item.textSup2 && <sup>{item.textSup2}</sup>}{" "}
                        {item.text2}
                      </p>
                    )}
                  </td>
                  <td className="tdContent">
                    {item.basicCheck && (
                      <p>
                        <img alt="check" src={Check} />
                      </p>
                    )}
                    {item.basic && <p>{item.basic}</p>}
                  </td>
                  <td></td>
                  <td className="tdContent">
                    {item.starterCheck && (
                      <p>
                        <img alt="check" src={Check} />
                      </p>
                    )}
                    {item.starter && <p>{item.starter}</p>}
                  </td>
                  <td></td>
                  <td className="tdContent">
                    {item.plusCheck && (
                      <p>
                        <img alt="check" src={Check} />
                      </p>
                    )}
                    {item.plus && <p>{item.plus}</p>}
                  </td>
                  <td></td>
                  <td className="tdContent">
                    {item.enterpriseCheck && <img alt="check" src={Check} />}
                    {item.enterprise && <p>{item.enterprise}</p>}
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      ) : (
        <>
          <div
            id="containerMenuStickyWithBanner"
            className={`containerMenuSticky ${stickyWithBanner}`}
          >
            <div
              className={
                openPlan
                  ? `containerSelectPlan containerPlanMobileOpen`
                  : "containerSelectPlan"
              }
            >
              {openPlan ? (
                <>
                  <div className="selectPlanText">Selecciona un plan</div>
                  <div
                    className="buttonCloseGray"
                    onClick={() => setOpenPlan(false)}
                  >
                    <img src={CrossGray} alt="close" />
                  </div>
                </>
              ) : (
                <>
                  <div
                    className="selectPlanTextClose"
                    onClick={() => setOpenPlan(true)}
                  >
                    {pricePlan[0].toUpperCase() + pricePlan.slice(1)}{" "}
                    <img src={Down} alt="" />
                  </div>
                  <div className="meInteresaMobileContainer">
                    <a
                      className="ButtonTablePrivilege meInteresaMobile"
                      href={`https://dashboard.etpay.com/sign-up?plan_selected=${
                        pricePlan[0].toUpperCase() + pricePlan.slice(1)
                      }`}
                    >
                      Me interesa
                    </a>
                  </div>
                </>
              )}
            </div>

            {openPlan && (
              <>
                <div className="contentDetailPlans">
                  <div className="contentDetailPlan padding-topNotBorder">
                    <div className="nameDetailsPlan">Basic</div>
                    <div
                      className="buttonDetailsPlan"
                      onClick={() => {
                        setPricePlan("basic");
                        setOpenPlan(false);
                      }}
                    >
                      <div>Ver en detalle</div>
                    </div>
                  </div>
                  <div className="contentDetailPlan borderOption">
                    <div className="nameDetailsPlan">Starter</div>

                    <div
                      className="buttonDetailsPlan"
                      onClick={() => {
                        setPricePlan("starter");
                        setOpenPlan(false);
                      }}
                    >
                      <div>Ver en detalle</div>
                    </div>
                  </div>
                  <div className="contentDetailPlan borderOption">
                    <div className="nameDetailsPlan">Plus</div>
                    <div
                      className="buttonDetailsPlan"
                      onClick={() => {
                        setPricePlan("plus");
                        setOpenPlan(false);
                      }}
                    >
                      <div>Ver en detalle</div>
                    </div>
                  </div>
                  <div className="contentDetailPlan borderOption">
                    <div className="nameDetailsPlan">Enterprise</div>
                    <div
                      className="buttonDetailsPlan"
                      onClick={() => {
                        setPricePlan("enterprise");
                        setOpenPlan(false);
                      }}
                    >
                      <div>Ver en detalle</div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* mobile version */}
          <table className="containerTable">
            <thead>
              <tr>
                <th className="Title">Aceptación de pagos </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {activeData.map((item, index) =>
                item.fullTitle ? (
                  <tr className="beneficioTitle">
                    <td class="FirstColumn">
                      <p class="beneficio"> {item.fullTitle} </p>
                    </td>
                    <td></td>
                  </tr>
                ) : (
                  <tr>
                    <td className="FirstColumn FirstColumnDirection">
                      {
                        <p className={item.tooltip && "pTooltip"}>
                          {item.titleSupIni && <sup>{item.titleSupIni}</sup>}
                          {item.title}{" "}
                          {item.titleSup && <sup>{item.titleSup}</sup>}
                          {item.tooltip && (
                            <ToolTip
                              title={item.tooltip}
                              index={index}
                              isActive={activeIndex === index}
                              onClick={handleToolTipClick}
                            />
                          )}
                        </p>
                      }

                      {item.text && (
                        <p className="textDescription">{item.text}</p>
                      )}
                      {item.text2 && (
                        <p className="textDescription">
                          {item.textSup2 && <sup>{item.textSup2}</sup>}{" "}
                          {item.text2}
                        </p>
                      )}
                    </td>
                    <td className="tdContent">
                      {pricePlan === "basic" && item.basicCheck && (
                        <p>
                          <img alt="check" src={Check} />
                        </p>
                      )}
                      {pricePlan === "basic" && item.basic && (
                        <p>{item.basic}</p>
                      )}
                      {pricePlan === "starter" && item.starterCheck && (
                        <p>
                          <img alt="check" src={Check} />
                        </p>
                      )}
                      {pricePlan === "starter" && item.starter && (
                        <p>{item.starter}</p>
                      )}
                      {pricePlan === "plus" && item.plusCheck && (
                        <p>
                          <img alt="check" src={Check} />
                        </p>
                      )}
                      {pricePlan === "plus" && item.plus && <p>{item.plus}</p>}
                      {pricePlan === "enterprise" && item.enterpriseCheck && (
                        <p>
                          <img alt="check" src={Check} />
                        </p>
                      )}
                      {pricePlan === "enterprise" && item.enterprise && (
                        <p>{item.enterprise}</p>
                      )}
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}
